import { useMemo, useState, useEffect, useRef } from "react";

import Descripation from "./Descripation";
import SpecificationsTab from "./SpecificationsTab";
import { useTranslation } from "next-i18next";
import Accessories from "./Accessories";
import UsersReviews from "./UsersReviews";
import ExpertReviews from "./ExpertReviews";
import AddOnSavings from "./AddOnSavings";
import { useRouter } from "next/router";
import Q_A from "./Q_A";
import AddOnSavingsMobile from "./AddOnSavingsMobile";
// import { retainKeys } from "@/utils/product";
// import { useClient } from "@/hooks/useClient";
// import { generateConfigurations } from "@/helpers/productDetails";

const ProductTabs = ({
  parentProduct,
  description,
  specifications,
  product_attributes,
  accessories,
  productReviews,
  bundle_discounts,
  relatedProducts,
  faqs,
  bundleSKUs: configurations,
}) => {
  const { t } = useTranslation("product");
  const [active, setActive] = useState("description");
  const router = useRouter();
  const tabsContainerRef = useRef(null);
  // const { isClient } = useClient()
  
  useEffect(() => {
    if (router.asPath) {
      const regex = /#product-tab-(.+)/;
      const match = router.asPath.match(regex);

      if (match && match.length > 1) {
        const extractedName = match[1];
        setActive(extractedName);
        tabsContainerRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [router]);

  // const configurations = bundleSKUs
  console.log('configurations ------- ', configurations)

  const tabsContent = useMemo(() => {
    return {
      description: {
        id: "description",
        title: t("Description"),
        disabled: false,
        content: (
          <section className="mx-auto max-sm:w-11/12 custom_description">
            <Descripation description={description} />
          </section>
        ),
      },
      additional: {
        id: "additional",
        title: t("Additional Information"),
        disabled: !specifications?.length,
        content: specifications?.map((item, idx) => (
          <section key={item.id || idx} className="mx-auto max-sm:w-11/12">
            <div
              className="product__dynamic-table max-sm:text-xs"
              dangerouslySetInnerHTML={{
                __html: item
                  .replace(
                    /<table[^>]*>/,
                    '<table style="width: 100%; border-collapse: collapse;">'
                  ) // Set table width to 100%
                  .replace(/<td[^>]*width:\s*\d+pt;[^>]*>/g, "<td>") // Remove fixed width from <td>
                  .replace(/<td[^>]*width=["'][^"']*["'][^>]*>/g, "<td>") // Remove width="" attribute from <td>
                  .replace(/<td[^>]*align=["'][^"']*["'][^>]*>/g, "<td>") // Remove width="" attribute from <td>
                  .replace(
                    /text-align:\s*[^;]*;/g,
                    "text-align: start; width: fit-content"
                  ) // Replace text alignment to start
                  .replace(/style="[^"]*"/g, (match) => {
                    // Keep only relevant styles
                    return match.includes("text-align")
                      ? match
                      : 'style="text-align: start;"';
                  }),
              }}
            />
          </section>
        )),
      },
      specifications: {
        id: "specifications",
        title: t("Specifications"),
        disabled: !product_attributes?.length,
        content: (
          <section className="mx-auto max-sm:w-11/12">
            <SpecificationsTab data={product_attributes} />,
          </section>
        ),
      },
      "user-reviews": {
        id: "user-reviews",
        disabled: !productReviews?.user_review_count,
        title: t("User Reviews"),
        content: (
          <section className="mx-auto max-sm:w-11/12">
            <UsersReviews productReviews={productReviews} />,
          </section>
        ),
      },
      "expert-reviews": {
        id: "expert-reviews",
        disabled: !productReviews?.pro_review_count,
        title: t("Expert Reviews"),
        content: (
          <section className="mx-auto max-sm:w-11/12">
            <ExpertReviews productReviews={productReviews} />,
          </section>
        ),
      },
      accessories: {
        id: "accessories",
        title: t("Accessories"),
        disabled: !accessories.length,
        content: <Accessories {...{ accessories }} />,
      },
      "bundle-discounts": {
        id: "bundle-discounts",
        title: t("Bundle discounts"),
        disabled: !bundle_discounts?.length || true,
        content: (
          <section className="mx-auto max-sm:w-11/12">
            <div className="max-sm:hidden">
              <AddOnSavings
                {...{
                  parentProduct,
                  bundle_discounts,
                  configurations,
                  relatedProducts,
                  t,
                }}
              />
            </div>
          </section>
        ),
      },
      "add-on-savings": {
        id: "add-on-savings",
        title: t("Add on savings"),
        disabled: !parentProduct?.ulmod_bundles?.length,
        content: (
          <section className="mx-auto max-sm:w-11/12">
            <div className="max-sm:hidden">
              <AddOnSavings
                {...{
                  parentProduct,
                  bundle_discounts: parentProduct?.ulmod_bundles,
                  configurations,
                  relatedProducts,
                  t,
                }}
              />
            </div>
            <div className="hidden max-sm:block">
              <AddOnSavingsMobile
                {...{
                  parentProduct,
                  t,
                }}
              />
            </div>
          </section>
        ),
      },
      q_a: {
        id: "q_a",
        title: t("Q&A"),
        disabled: false,
        content: (
          <section className="mx-auto max-sm:w-11/12">
            <Q_A faqs={faqs} t={t} parentProduct={parentProduct} />
          </section>
        ),
      },
    };
  }, [t, description, specifications, product_attributes, productReviews, accessories, bundle_discounts, parentProduct, configurations, relatedProducts, faqs]);

  return (
    <section>
      <div
        className="flex items-center gap-5 pt-8 mb-4 overflow-auto border-b lg:gap-20 max-sm:px-4"
        id={`product-tab-${active}`}
        ref={tabsContainerRef}
      >
        {Object.values(tabsContent)?.map(
          (tab, idx) =>
            !tab?.disabled && (
              <button
                key={tab.id || idx}
                onClick={() => setActive(tab?.id)}
                disabled={tab?.disabled}
                className={`${
                  active === tab?.id &&
                  "border-b border-b-tertiary-800 text-tertiary-800 font-bold"
                } transition-all w-fit pb-2.5 whitespace-nowrap text-xs sm:text-base hover:border-b hover:border-b-tertiary-800 hover:text-tertiary-800`}
              >
                {tab?.title || ""}
              </button>
            )
        )}
      </div>
      {tabsContent[active]?.content || ""}
    </section>
  );
};

export default ProductTabs;
